<template>
  <basic-container class="autoSetting">
    <section v-if="isSign">
      <h3>自动接单设置</h3>
      <div class="d-f m-t-10 align-c">
        <label class="w-110 f-s-14 f-w-600">工作时间设置</label>
        <vue-drag-timepicker v-model="timeValue" @change="handleChange" />
      </div>
      <p class="p-l-110 f-s-12 c-333 m-b-5">
        合计：
        <span class="c-primary f-w-600">
          {{ (timeValue.match(/1/g) || []).length * 0.5 }}
        </span>
        小时
      </p>
      <p class="p-l-110 f-s-12 f-w-600 m-t-10 c-999 m-b-5">
        <span class="c-red">*</span>
        工作时间：指可以在此时间段内接受并交付订单（有效工作时间不能小于4小时）；
      </p>
      <div class="d-f m-t-10 align-c f-s-14">
        <label class="w-110 f-s-14 f-w-600">每小时产能设置</label>
        <el-input-number
          :class="[
            wordNum == null || wordNum < minCapacity
              ? 'w-85 m-r-5 border-red'
              : 'w-85 m-r-5',
          ]"
          :controls="false"
          :precision="0"
          :min="0"
          v-model="wordNum"
          placeholder="请输入"
        />
        字
      </div>
      <p class="p-l-110 f-s-12 f-w-600 m-t-10 c-999">
        <span class="c-red">*</span>
        每小时产能：指工作时间范围内，每小时可以翻译的字数；最小不得低于{{
          minCapacity
        }}字；
      </p>
      <div class="d-f m-t-10 align-c f-s-14">
        <label class="w-110 f-s-14 f-w-600">系统派单开关</label>
        <el-switch v-model="switchValue"></el-switch>
      </div>
      <p class="p-l-110 f-s-12 f-w-600 m-t-10 c-999">
        仅适用于临时无法急事无法处理订单的场景，24小时候系统将会自动开启接单开关；操作开关后下一单开始生效；
      </p>
      <div class="p-l-110 m-t-20">
        <el-button type="primary" @click="saveSetting">保 存</el-button>
      </div>
    </section>
    <div v-else class="p-tb-40 t-c">暂无权限……</div>
  </basic-container>
</template>

<script>
import {
  getQcInfoByStaffId,
  getQcWorkConfig,
  saveOrupdateWorkConfig,
} from '@/api/dot/qc';
import { mapState } from 'vuex';
import VueDragTimepicker from '../../components/time-picker/vue-drag-timepicker';
export default {
  name: 'autoSetting',
  components: {
    VueDragTimepicker,
  },
  data() {
    return {
      isSign: null,
      timeValue: '000000000000000000000000000000000000000000000000',
      wordNum: 1000,
      switchValue: true,
      selectFlag: null,
      timeScope: null,
      timeoutId: null,
      minCapacity: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    this.getConfigInfo();
  },
  methods: {
    handleChange(val, timeScope) {
      this.selectFlag = val;
      this.timeScope = timeScope[0]?.times
        .map((item) => {
          return item.from + '-' + item.to;
        })
        .join(',');
    },

    blurWordNum() {
      this.getConfigInfo();
      this.timeoutId = setTimeout(() => {
        if (this.wordNum < this.minCapacity) {
          this.wordNum = undefined;
          this.$message.error(
            `请重新输入，每小时产能不得低于${this.minCapacity}字！`,
          );
        }
      }, 200);
    },

    // 获取配置信息
    getConfigInfo() {
      getQcWorkConfig({
        staffId: this.userInfo.staffId,
      }).then((res) => {
        const data = res?.data?.data;
        this.isSign = Number(data?.circleSwitch);
        this.wordNum = data?.capacity ?? 1000;
        this.minCapacity = data?.minCapacity;
        this.switchValue = data
          ? data?.singleSwitch === '1'
            ? true
            : false
          : true;
        this.timeValue = data?.timeMark ?? this.timeValue;
      });
    },

    // 保存
    saveSetting() {
      this.timeoutId = null;
      clearTimeout(this.timeoutId);
      let count = (this.timeValue.match(/1/g) || []).length;
      if (count < 8) {
        this.$message.error('有效的工作时段必须大于4小时');
        return;
      }
      if (!this.wordNum || this.wordNum < this.minCapacity) {
        this.$message.error('请设置符合要求的产能');
        return;
      }
      saveOrupdateWorkConfig({
        id: this.userInfo.staffId,
        workTime: this.timeScope,
        capacity: this.wordNum,
        timeMark: this.selectFlag,
        singleSwitch: this.switchValue ? 1 : 0,
        operator: this.userInfo.realname,
      })
        .then((res) => {
          this.$message.success(
            this.switchValue
              ? '保存成功'
              : '保存成功！已关闭系统派单开关，有效期24小时',
          );
        })
        .catch(() => {
          this.getConfigInfo();
        });
    },
  },
};
</script>
